import React, { useState } from "react";
import helperFunction from "../../Function/helperFunction";

const initialValues = {
  kilogram: "", 
  length: "", 
  width: "", 
  height: "",
  volume: "",

  rate_per_base_wood_sheet: "",
  rate_per_corner_wood_bar: "",
  rate_per_wooden_sheet: "",

  one_wooden_sheet_area: 2.97,
  one_corner_wooden_area: 4.24,
  one_base_wooden_area: 2.97,

  total_req_surface_area_of_the_Product: 0,
  total_req_corner_wood_area_of_the_product: 0,
  total_req_base_wood_area_of_the_product: 0,

  total_req_surface_area_of_the_Product_wastage: 0,
  total_req_corner_wood_area_of_the_product_wastage: 0,
  total_req_base_wood_area_of_the_product_wastage: 0,

  total_wooden_sheet_required: 0,
  total_corner_wood_bar_required: 0,
  total_base_wood_sheet_required: 0,
  
  total_wooden_sheet_cost: 0,
  total_corner_wood_bar_cost: 0,
  total_base_wood_sheet_cost: 0,

  labour_cost : 0,
  screw_charges : 20,
  total_cost_wooden_box : 0,

  after_packing_weight : {
    total_sq_mt: 0,
    weight_increase: 0,
    box_final_weight: 0,
  },

  after_packing_dims : {
    length: 0,
    width: 0,
    height: 0,
  },
};


const WoodenBoxCalculators = () => {
  const [state, setState] = useState(initialValues)


  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => {
      prev[name] = Number(value)
      const allFields = calculateAllFields(prev)
      return ({
        ...prev,
        ...allFields
      })
  });
  }

    const handleReset = ()=>{
      setState(initialValues)
    }

    const calculateAllFields = (values) => {
      const { kilogram, length, width, height } = values;
      const volume = (length * width * height) / 1000000;

      const total_req_surface_area_of_the_Product = 2*(length * width)/10000 + 2*(width * height)/10000 + 2*(length * height)/10000;
      const total_req_corner_wood_area_of_the_product = 4*(length + width)/100 + 4*(width + height)/100 + 4*(length + height)/100
      const total_req_base_wood_area_of_the_product = (length * width) / 10000;

      const total_req_surface_area_of_the_Product_wastage = total_req_surface_area_of_the_Product * 1.2;
      const total_req_corner_wood_area_of_the_product_wastage = total_req_corner_wood_area_of_the_product * 1.2;
      const total_req_base_wood_area_of_the_product_wastage = total_req_base_wood_area_of_the_product * 1.2;

      const total_wooden_sheet_required = total_req_surface_area_of_the_Product_wastage / values.one_wooden_sheet_area;
      const total_corner_wood_bar_required = total_req_corner_wood_area_of_the_product_wastage / values.one_corner_wooden_area;
      const total_base_wood_sheet_required = total_req_base_wood_area_of_the_product_wastage / values.one_base_wooden_area;
      
      const total_wooden_sheet_cost =    total_wooden_sheet_required * values.rate_per_wooden_sheet;
      const total_corner_wood_bar_cost = total_corner_wood_bar_required * values.rate_per_corner_wood_bar;
      const total_base_wood_sheet_cost = total_base_wood_sheet_required * values.rate_per_base_wood_sheet;

      const labour_cost = (volume * 25) > 25 ? volume * 25 : 25 ;
      const total_cost_wooden_box = total_wooden_sheet_cost + total_corner_wood_bar_cost + total_base_wood_sheet_cost + labour_cost + values.screw_charges;

      const after_packing_total_sq_mt      = total_req_surface_area_of_the_Product_wastage + total_req_base_wood_area_of_the_product_wastage
      const after_packing_weight_increase  = after_packing_total_sq_mt * 2.6
      const after_packing_box_final_weight = after_packing_weight_increase + kilogram

      return {
        volume: volume,

        total_req_surface_area_of_the_Product : helperFunction.handleDecimalPoints(total_req_surface_area_of_the_Product,2,true),
        total_req_corner_wood_area_of_the_product : helperFunction.handleDecimalPoints(total_req_corner_wood_area_of_the_product,2,true),
        total_req_base_wood_area_of_the_product : helperFunction.handleDecimalPoints(total_req_base_wood_area_of_the_product,2,true),

        total_req_surface_area_of_the_Product_wastage : helperFunction.handleDecimalPoints(total_req_surface_area_of_the_Product_wastage,1,true),
        total_req_corner_wood_area_of_the_product_wastage : helperFunction.handleDecimalPoints(total_req_corner_wood_area_of_the_product_wastage,1,true),
        total_req_base_wood_area_of_the_product_wastage : helperFunction.handleDecimalPoints(total_req_base_wood_area_of_the_product_wastage,1,true),

        total_wooden_sheet_required : helperFunction.handleDecimalPoints(total_wooden_sheet_required,6,true),
        total_corner_wood_bar_required : helperFunction.handleDecimalPoints(total_corner_wood_bar_required,6,true),
        total_base_wood_sheet_required : helperFunction.handleDecimalPoints(total_base_wood_sheet_required,6,true),
        
        total_wooden_sheet_cost : helperFunction.handleDecimalPoints(total_wooden_sheet_cost,5,true),
        total_corner_wood_bar_cost : helperFunction.handleDecimalPoints(total_corner_wood_bar_cost,5,true),
        total_base_wood_sheet_cost : helperFunction.handleDecimalPoints(total_base_wood_sheet_cost,5,true),

        labour_cost : helperFunction.handleDecimalPoints(labour_cost,1,true),
        total_cost_wooden_box : Math.round(total_cost_wooden_box),

        after_packing_weight : {
          total_sq_mt:      helperFunction.handleDecimalPoints(after_packing_total_sq_mt,2,true),
          weight_increase:  helperFunction.handleDecimalPoints(after_packing_weight_increase,2,true),
          box_final_weight: helperFunction.handleDecimalPoints(after_packing_box_final_weight,2,true),
        },

        after_packing_dims : {
          length: length + 6,
          width: width + 6,
          height: height + 15,
        },
    }
  }

  return (
    <div>
      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered table-centered table-nowrap mb-0">
              <thead className="table-light">
                <tr>
                  <th colSpan={4} className="text-center">
                    Cargo Details
                  </th>
                  <th rowSpan={2} className="text-center">
                    Volume
                  </th>
                </tr>
                <tr>
                  <th className="text-center">Kilogram</th>
                  <th className="text-center">Length</th>
                  <th className="text-center">Width</th>
                  <th className="text-center">Height</th>
                </tr>
              </thead>
              <tbody>
                {/* cargo detail-------------------------------------------------------- */}
                <tr>
                  {["kilogram", "length", "width", "height"].map((item, i) => (
                    <td>
                      <input
                        key={i}
                        type="number"
                        className="form-control"
                        name={item}
                        value={state[item]}
                        onChange={handleChange}
                        placeholder={item}
                      />
                    </td>
                  ))}
                  <td style={{ width: "20%" }} className="text-center">
                    {state?.volume || 0}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* wooden---------------------------------------------------------------- */}
      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered table-centered table-nowrap mb-0">
              <thead className="table-light">
                <tr>
                  <th className="text-center" colSpan={3}>
                    Wooden Material (Rate)
                  </th>
                  <th className="text-center" colSpan={3}>
                    Area
                  </th>
                </tr>
                <tr>
                  <th className="text-center">Per Wooden Sheet</th>
                  <th className="text-center">Per Corner Wood Bar</th>
                  <th className="text-center">Per Base Wood Sheet</th>
                  <th className="text-center">1 Wooden Sheet ( Sq Mt )</th>
                  <th className="text-center">1 Corner Wooden ( Mt )</th>
                  <th className="text-center">1 Base Wooden ( Sq Mt )</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  {[
                    "rate_per_wooden_sheet",
                    "rate_per_corner_wood_bar",
                    "rate_per_base_wood_sheet",
                    "one_wooden_sheet_area",
                    "one_corner_wooden_area",
                    "one_base_wooden_area",
                  ].map((item, i) => (
                    <td>
                      <input
                        key={i}
                        type="number"
                        className="form-control"
                        name={item}
                        value={state[item]}
                        onChange={handleChange}
                        placeholder="Enter Value"
                      />
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* total------------------------------------------------------------------------- */}
      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered table-centered table-nowrap mb-0">
              <thead className="table-light">
                <tr>
                  <th className="text-center" colSpan={2}></th>
                  <th className="text-center">Wastage ( 20%)</th>
                  <th colSpan={2} className="text-center"></th>
                  <th colSpan={2} className="text-center"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Total Req Surface Area of the Product ( Sq Mt )</td>{" "}
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Total Req Surface Area of the Product ( Sq Mt)"
                      disabled
                      value={state?.total_req_surface_area_of_the_Product}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Total Req Surface Area of the Product Wastage ( Sq Mt)"
                      disabled
                      value={
                        state?.total_req_surface_area_of_the_Product_wastage
                      }
                    />
                  </td>
                  <td>Total Wooden Sheet Required</td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Total Wooden Sheet Required"
                      disabled
                      value={state?.total_wooden_sheet_required}
                    />
                  </td>
                  <td>Total Wooden Sheet Cost</td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Total Wooden Sheet Cost"
                      disabled
                      value={state?.total_wooden_sheet_cost}
                    />
                  </td>
                </tr>
                <tr>
                  <td>Total Req Corner Wood Area of the Product ( Mt )</td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Total Req Corner Wood Area of the Product ( Mt)"
                      disabled
                      value={state?.total_req_corner_wood_area_of_the_product}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Total Req Corner Wood Area of the Product Wastage ( Mt)"
                      disabled
                      value={
                        state?.total_req_corner_wood_area_of_the_product_wastage
                      }
                    />
                  </td>
                  <td>Total Corner Wood Bar Required</td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Total Corner Wood Bar Required "
                      disabled
                      value={state?.total_corner_wood_bar_required}
                    />
                  </td>
                  <td>Total Corner Wood Bar Cost</td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Total Corner Wood Bar Cost"
                      disabled
                      value={state?.total_corner_wood_bar_cost}
                    />
                  </td>
                </tr>
                <tr>
                  <td>Total Req Base Wood Area of the Product (Sq Mt )</td>{" "}
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Total Req Base Wood Area of the Product (Sq Mt)"
                      disabled
                      value={state?.total_req_base_wood_area_of_the_product}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Total Req Base Wood Area of the Product Wastage (Sq Mt)"
                      disabled
                      value={
                        state?.total_req_base_wood_area_of_the_product_wastage
                      }
                    />
                  </td>
                  <td>Total Base Wood Sheet Required</td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Total Base Wood Sheet Required "
                      disabled
                      value={state?.total_base_wood_sheet_required}
                    />
                  </td>
                  <td>Total Base Wood Sheet Cost</td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Total Base Wood Sheet Cost"
                      disabled
                      value={state?.total_base_wood_sheet_cost}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* total cost----------------------------------------------------------------------------- */}
      <div
        className="mt-2 text-center p-2 mb-4 d-flex justify-content-evenly"
        style={{ border: "1px solid #c9ced2" }}
      >
        <p className="mb-1">
          <span className="fw-bold">Labour Cost (Every cbm Aed 25/-) : </span>{" "}
          {state?.labour_cost}
        </p>
        <p className="mb-1">
          <span className="fw-bold">Screw Charges ( AED) : </span> 20
        </p>
        <p className="mb-1">
          <span className="fw-bold">Total Cost of Wooden Box : </span>
          {state?.total_cost_wooden_box}
        </p>
        {/* </td> */}
      </div>

      {/* After Packing Weight----------------------------------------------------------------------------- */}
      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered table-centered table-nowrap mb-0">
              <thead className="table-light">
                <tr>
                  <th className="text-center" colSpan={3}>
                    After Packing Weight
                  </th>
                  <th className="text-center" colSpan={4}>
                    Dims after Packing
                  </th>
                </tr>
                <tr>
                  <th className="text-center">Total Sq Mt</th>
                  <th className="text-center">Weight Increase ( kgs)</th>
                  <th className="text-center">Box Final Wt after Packing</th>
                  <th className="text-center">L ( cms )</th>
                  <th className="text-center">W ( cms )</th>
                  <th className="text-center">H ( cms )</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="fw-bold text-center">
                    {state?.after_packing_weight.total_sq_mt}
                  </td>
                  <td className="fw-bold text-center">
                    {state?.after_packing_weight.weight_increase}
                  </td>
                  <td className="fw-bold text-center">
                    {state?.after_packing_weight.box_final_weight}
                  </td>
                  <td className="fw-bold text-center">
                    {state?.after_packing_dims.length}
                  </td>
                  <td className="fw-bold text-center">
                    {state?.after_packing_dims.width}
                  </td>
                  <td className="fw-bold text-center">
                    {state?.after_packing_dims.height}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="mt-3 d-flex justify-content-between">
        <button
          className="btn btn-danger w-sm waves-effect waves-light"
          type="button"
          onClick={() => handleReset()}
        >
          Reset
        </button>
      </div>
    </div>
  );
};

export default WoodenBoxCalculators;
